var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-or-placeholder"},[(_vm.url)?_c('img',{attrs:{"src":_vm.url}}):_vm._e(),(!_vm.url && _vm.imageUrl)?_c('img',{attrs:{"src":_vm.imageUrl}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }